import {LocationDao} from '../../dao';
import {ErrorModel, LocationModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { UserState } from '../../reducers/UserReducer';

const FUNCTION_CODE = 'GET_ALL_LOCATIONS';

export async function getAllLocations(
    userData: UserState["userProfileData"],
    params: string,
    page: number,
) {
    try {
        const locations = await LocationDao.getAllLocations(userData?.userToken as string, params, page);

        const locationParsed = locations.results.map((location: Record<string, any>) => LocationModel.parseLocation(location));

        locationParsed.sort((a: { name: string }, b: { name: string }) => {
            const numA = parseInt(a.name, 10);
            const numB = parseInt(b.name, 10);
            if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
            return a.name.localeCompare(b.name);
        });

        return locationParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des localisations',
            error: error
        });
    }
}
